export class AppDOM {
    constructor(app) {
        this.app = app || document;
    }

    select(query) {
        return this.app.querySelector(query);
    }

    selectAll(query) {
        return Array.from(this.app.querySelectorAll(query));
    }
}

export const create = (el, attrs) => {
    const node = document.createElement(el);
    if (attrs) {
        const attributes = Object.keys(attrs);
        for (let i = 0; i < attributes.length; i++) {
            const attribute = attributes[i];
            node.setAttribute(attribute, attrs[attribute]);
        }
    }
    return node;
};

export const text = str => {
    return document.createTextNode(str);
};

export const clear = el => {
    while (el.firstChild) {
        el.removeChild(el.firstChild);
    }
};

export default {
    text: text,
    clear: clear,
    AppDOM: AppDOM,
    create: create,
};
